import {styled} from '@mui/material/styles'
import {Box} from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

const PREFIX = 'DataRefetchOnError'

export const classes = {
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

export const StyledBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [`& .${classes.icon}`]: {
    color: theme.palette.grey[200]
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[700]
  },
  padding: theme.spacing(2.5)
}))

export const StyledErrorOutlineIcon = styled(ErrorOutlineIcon)(() => ({
  width: '0.4em',
  height: '0.4em',
  fontSize: 'calc(80px + 2vh)'
}))
